export function getLocalStorageByKey(key, defaultValue) {
    if (typeof window === 'undefined') {
        throw new Error('Failed to load window');
    }
    const storedString = localStorage.getItem(key);
    if (!storedString) {
        return defaultValue;
    }
    return JSON.parse(storedString);
}
export function setLocalStorageByKey(key, value) {
    if (typeof window === 'undefined') {
        throw new Error('Failed to load window');
    }
    localStorage.setItem(key, JSON.stringify(value));
}
//# sourceMappingURL=localstorage.js.map